type Config = {
  [K in (typeof AppConfig.fields)[number]]: string
}

class AppConfig {
  static readonly fields = ['VITE_LEEA_TG_API_URL'] as const

  private readonly requiredFiedls: Partial<typeof AppConfig.fields> = ['VITE_LEEA_TG_API_URL']

  private container!: Config

  constructor(config: any) {
    this.init(config)
    this.validate()
  }

  private init(config: any): void {
    this.container = AppConfig.fields.reduce((acc, field) => {
      acc[field] = config[field]
      return acc
    }, {} as Config)
  }

  private validate(): void {
    for (const field of this.requiredFiedls) {
      // @ts-ignore
      if (!this.container[field]) {
        throw new Error(`Не задан ${field}`)
      }
    }
  }

  get value(): Config {
    return this.container
  }
}

const configInstance = new AppConfig(import.meta.env)

export const appConfig = configInstance.value
